export const PLANS = [
  {
    name: 'Basic',
    value: 'basic',
    monthlyPrice: 25,
    yearlyPrice: 250,
    maxProjectsCount: 3,
    description: 'Perfect for individuals or small teams just getting started',
    prices: {
      monthly: window.location.hostname === 'app.qlerify.com' ? 'price_1RD5yXALrMdFlaXPltMstvIv' : 'price_1QRUjHALrMdFlaXPttQI8y0K',
      yearly: window.location.hostname === 'app.qlerify.com' ? 'price_1RD5yXALrMdFlaXPQ2vuB0Eo' : 'price_1QRUjHALrMdFlaXPKdK19nDM'
    },
    features: ['10GB of storage for documents and attachments', '3 Projects', '5 Workflows per project', 'Unlimited Visitors (1-click access, no sign-in)', 'Unlimited amount of AI prompts']
  },
  {
    name: 'Pro',
    value: 'pro',
    monthlyPrice: 40,
    yearlyPrice: 400,
    maxProjectsCount: Infinity,
    description: 'Ideal for growing teams and businesses',
    prices: {
      monthly: window.location.hostname === 'app.qlerify.com' ? 'price_1RD5yRALrMdFlaXP5IaW68OL' : 'price_1QRUkfALrMdFlaXPmR5WZ9G9',
      yearly: window.location.hostname === 'app.qlerify.com' ? 'price_1RD5yRALrMdFlaXPSaRp1XjS' : 'price_1QRUkfALrMdFlaXPOT0g83yb'
    },
    features: ['Card required, but you won\'t be charged for 4 weeks. Cancel anytime.', 'Unlimited number of projects', 'Unlimited number of workflows', 'Unlimited number of documents and attachments', 'Priority email support', 'On-boarding and training sessions', '99.9% uptime guarantee']
  }
]

export const ENTERPRISE_PLAN = {
  name: 'Enterprise',
  value: 'enterprise',
  maxProjectsCount: Infinity,
  description: 'Custom solutions for large organizations',
  features: ['Dedicated account manager', 'Custom integrations', 'Advanced and customized security features', 'Custom training and workshops', 'Phone and video support', 'SSO (Single sign-on) integration', 'Access to early feature releases', 'Custom continued education and webinars']
}

export function getPlanByPriceId (priceId) {
  return PLANS.find((plan) => [plan.prices.monthly, plan.prices.yearly].includes(priceId))
}

export function getSubscriptionTypeByPriceId (priceId) {
  const isMonthly = PLANS.findIndex((plan) => [plan.prices.monthly].includes(priceId)) !== -1
  const isYearly = PLANS.findIndex((plan) => [plan.prices.yearly].includes(priceId)) !== -1

  return isMonthly ? 'monthly' : isYearly ? 'yearly' : null
}

export function getSubscriptionAccessType (activeSubscription) {
  if (!activeSubscription || activeSubscription.subscriptionDetails?.status === 'unpaid') {
    return 'NO_ACCESS'
  }

  const isEnterpriseUser = !!activeSubscription && activeSubscription?.subscriptionDetails?.subscriptionId?.startsWith('ecus_')
  const isSubscriptionActive = ['active', 'trialing'].includes(activeSubscription?.subscriptionDetails?.status)
  const lastSubscriptionDetails = activeSubscription?.lastSubscriptionDetails

  return isSubscriptionActive ? 'FULL' : isEnterpriseUser || lastSubscriptionDetails ? 'LIMITED' : 'NO_ACCESS'
}
